
function FormattedDate(props) {
  const utctime = props.date;

  var t = utctime.split(" ");
  var utcd = t[0].split("-");
  var utct = t[1].split(":");
  var d = new Date(utcd[0], utcd[1]-1, utcd[2], utct[0], utct[1], utct[2]);
  var now = new Date();
  now = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),  now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
  var diff = now-d;
  var secs = Math.round(diff/1000);
  var mins = Math.floor(secs/60);
  var hours = Math.floor(mins/60);
  var days = Math.floor(hours/24);
  var years = Math.floor(days/365);
  // XXX check if this formula is correct.
  secs = secs % 60;
  mins = mins % 60;
  hours = hours % 24;
  days = days % 365;

  var hr_date = "";
  var hr_date_full = "";
  var hr = 0;

  if (years > 0) {
      hr_date += years + "y ";
      hr += 1;
      if (years > 1) {
          hr_date_full += years + " years ";
      } else {
          hr_date_full += years + " year ";
      }
  }

  if (days > 0) {
      hr_date += days + "d ";
      hr += 1;
      if (days > 1) {
          hr_date_full += days + " days ";
      } else {
          hr_date_full += days + " day ";
      }
  }

  if (hours > 0) {
      hr_date += hours + "h ";
      hr += 1;
      if (hours > 1) {
          hr_date_full += hours + " hours ";
      } else {
          hr_date_full += hours + " hour ";
      }
  }


  if (mins > 0) {
      if (hr < 2) {
          hr_date += mins + "m ";
          hr += 1;
      }
      if (hours > 1) {
          hr_date_full += mins + " minutes ";
      } else {
          hr_date_full += mins + " minute ";
      }
  }

  if (hr < 2) {
      hr_date += secs + "s ";
      hr += 1;
  }
  if (hr > 1) {
      hr_date_full += "and ";
  }
  if (secs > 1) {
      hr_date_full += secs + " seconds";
  } else {
      hr_date_full += secs + " second";
  }

  if (props.full)
    return hr_date_full;
  else
    return hr_date;
}

export default FormattedDate;
